import type { LeadsSearchFilterInstance, OrderedFilterInstance } from "../types/leadsSearchFilterInstance";

export function withOrder(filter: LeadsSearchFilterInstance, order: number): OrderedFilterInstance;
export function withOrder(
    filter: LeadsSearchFilterInstance | undefined,
    order: number,
): OrderedFilterInstance | undefined;
export function withOrder(
    filter: LeadsSearchFilterInstance | undefined,
    order: number,
): OrderedFilterInstance | undefined {
    if (!filter) {
        return undefined;
    }
    filter.order = order;
    return filter as OrderedFilterInstance;
}
